import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { AppDialogBox } from "../common/ui/AppDialogBox";
import UserForm from "./UserForm";
import { actionTypes } from "../../store/actionTypes/actionTypes";
import { ADMIN } from "../../constants/admin";

interface UserFormDilogContainerProps {
  onRefresh: () => void;
}

const UserFormDilogContainer: React.FC<UserFormDilogContainerProps> = ({ onRefresh }) => {
  const dispatch = useDispatch();

  const userFormOpen = useSelector(
    (state: any) => state.userManagement?.userFormOpen || false
  );

  const userFormType = useSelector(
    (state: any) => state.userManagement?.userFormType || ADMIN.MEETING_FORM_TYPE.CREATE
  );

  const dialogTitle =
    userFormType === ADMIN.MEETING_FORM_TYPE.EDIT
      ? "Update User"
      : "Create User";

  const handleDialogClose = () => {
    dispatch({
      type: actionTypes.UPDATE_USER_FORM_OPEN,
      payload: false,
    });
    dispatch({
      type: actionTypes.UPDATE_SELECTED_USER_DATA,
      payload: null,
    });
    dispatch({
      type: actionTypes.UPDATE_USER_FORM_TYPE,
      payload: ADMIN.MEETING_FORM_TYPE.CREATE,
    });
  };

  return (
    <>
      <AppDialogBox
        btnText1={"test"}
        title={dialogTitle}
        isDialogOpen={userFormOpen}
        handleDialogClose={handleDialogClose}
        className='de-form-dialog-box-container'
      >
        <Box className='user-form-container'>
          <UserForm handleDialogClose={handleDialogClose} onRefresh={onRefresh} />
        </Box>
      </AppDialogBox>
    </>
  );
};

export default UserFormDilogContainer;

